


























































/**
 * FUPOF-193: asked the first time a rep changes a design that still matches
 * its Shade Designer configuration code. Cancel (and the X, and the backdrop)
 * emits `close`, on which the page puts the design back; Continue emits
 * `confirm`. Built on the same frame as ConfirmDelete / ConfirmClearAll.
 */

import { Vue, Component, Prop } from "vue-property-decorator";
@Component
export default class ConfirmDesignDeviation extends Vue {
  @Prop({ default: "Adjust Shade Designer Configuration" }) title!: string;
  @Prop({ default: "" }) code!: string;

  protected closeModal(): void {
    this.$emit("close");
  }
}
